import { MdAutorenew, MdTaskAlt, MdPaid } from "react-icons/md";
import "./StatusSelector.css";

export const STATUS_STEPS = [
  { key: "PROCESSING", label: "Processing", Icon: MdAutorenew, hint: "Payment received and processing" },
  { key: "READY", label: "Ready", Icon: MdTaskAlt, hint: "Ready for payout" },
  { key: "PAID", label: "Paid", Icon: MdPaid, hint: "Recipient has received the money" },
];

export default function StatusSelector({ value, onChange, disabled, lockBackward = true, showHint = true }) {
  const currentIndex = STATUS_STEPS.findIndex(s => s.key === value);
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <label className="form-label fw-bold mb-1">Update Status</label>
        {showHint && (
          <small className="text-muted mb-1 d-none d-sm-inline">
            {STATUS_STEPS[currentIndex]?.hint}
          </small>
        )}
      </div>
      {showHint && (
        <div className="small text-muted mb-2 d-sm-none">
          {STATUS_STEPS[currentIndex]?.hint}
        </div>
      )}

      <ul className="status-grid list-unstyled" role="tablist">
        {STATUS_STEPS.map((s, idx) => {
          const isActive = value === s.key;
          const isPassed = idx < currentIndex;
          const isDisabled = !!disabled || (lockBackward && isPassed) || value === "PAID";

          const base =
            "w-100 rounded-pill fw-semibold d-inline-flex align-items-center justify-content-center gap-2";
          const variant = isActive
            ? "btn btn-success text-white"
            : isPassed
              ? "btn btn-outline-success "
              : "btn btn-outline-secondary";

          return (
            <li key={s.key} className="status-item">
              <button
                type="button"
                aria-current={isActive ? "page" : undefined}
                className={`${base} ${variant} status-btn`}
                onClick={() => !isDisabled && onChange(s.key)}
                disabled={isDisabled}
                style={{ padding: ".2rem .9rem"}}
              >
                <s.Icon size={18} />
                <span className="status-label">{s.label}</span>
              </button>
            </li>
          );
        })}
      </ul>

      <div className="progress mt-3" style={{ height: 6 }}>
        <div
          className="progress-bar bg-success"
          role="progressbar"
          style={{ width: `${((currentIndex + 1) / STATUS_STEPS.length) * 100}%` }}
          aria-valuenow={currentIndex + 1}
          aria-valuemin={0}
          aria-valuemax={STATUS_STEPS.length}
        />
      </div>
    </div>
  );
}
